import { FC, useState } from 'react'
import * as Yup from 'yup'
import { useFormik, ErrorMessage } from 'formik'
import { allcountryList, isNotEmpty, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { initialUser, User } from '../core/_models'
import clsx from 'clsx'
import { useListView } from '../core/ListViewProvider'
import { UsersListLoading } from '../components/loading/UsersListLoading'
import { createUser, updateUser } from '../core/_requests'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { errorToast, successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import UploadImage from '../../../../../../_metronic/helpers/components/ImageUpload'
import { useAuth } from '../../../../auth'
import { useQueryRequest } from '../core/QueryRequestProvider'

type Props = {
    isUserLoading: boolean
    user?: User | any,
    onClose?: () => void
}

const editUserSchema = Yup.object().shape({
    amount: Yup.string().required('Enter amount'),
    // paymentProof: Yup.string().required('Upload proof of payment image'),
    // transactionType: Yup.string().required('Select type'),
    // currency: Yup.string().required('Select Currency'),
})

const WCC2: FC<Props> = ({ user = {}, isUserLoading, onClose }) => {
    const { setItemIdForUpdate, itemIdForUpdate } = useListView()
    const { state } = useQueryRequest()

    console.log({ state: state.initialApi?.split('/')[2] })

    const { refetch, response }: any = useQueryResponse()
    const [userForEdit] = useState<any>({

        // ...user,
        // currency: user.currency || 'USD',
        // transactionType: user.transactionType || 'CR',
        amount: user.amount || '',
        // paymentProof: user.paymentProof || '',
        paymentProof: user.paymentProof || '',
        // date: new Date().getTime(),
        currency: 'USD',
        transactionType: 'DR',
    })

    const cancel = (withRefresh?: boolean) => {
        setItemIdForUpdate(undefined)

        if (withRefresh) {
            // Successful submit: close modal and refresh page
            refetch()
            if (onClose) {
                onClose()
            }
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        } else {
            // Regular cancel: only close modal
            if (onClose) {
                onClose()
            }
        }
    }
    const formik: any = useFormik({
        initialValues: userForEdit,
        validationSchema: editUserSchema,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            try {
                const payload = {
                    ...values,
                    currency: 'USD',
                    transactionType: 'DR',
                }
                if (isNotEmpty(user.userId)) {
                    await createUser(payload, 'convertor/payment/' + user.userId)
                    successToast('Modified')
                    cancel(true)
                } else {
                    await createUser(payload, `user/payment/${state.initialApi?.split('/')?.[2]}`)
                    successToast('Added')
                    cancel(true)
                }
            } catch (ex) {
                errorToast('Somethig Went Wrong')
                console.error(ex)
            } finally {
                setSubmitting(false)
            }
        },
    })

    const makeSelectDropDown = (name = '', options: any = []) => {
        return (
            <>
                <select
                    className={clsx(
                        'form-control form-control-solid mb-3 mb-lg-0',
                        { 'is-invalid': formik.touched[name] && formik.errors[name] },
                        {
                            'is-valid': formik.touched[name] && !formik.errors[name],
                        }
                    )}
                    {...formik.getFieldProps(name)}
                >
                    <option value=''>Select one...</option>
                    {options.map((eachOption, eachInd) => (
                        <option key={eachInd + 1 + ''} value={eachOption.value}>
                            {eachOption.label}
                        </option>
                    ))}
                </select>
                {formik.errors[name] && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors[name]}</span>
                        </div>
                    </div>
                )}
            </>
        )
    }

    const identificationList = [
        { label: 'Debit', value: 'DR' },
        { label: 'Credit', value: 'CR' },
    ]

    const currency = [
        { label: 'USD', value: 'USD' },
        { label: 'GBP', value: 'GBP' },
        { label: 'AUD', value: 'AUD' },
        { label: 'JPY', value: 'JPY' },
        { label: 'SEK', value: 'SEK' },
        { label: 'CAD', value: 'CAD' },
        { label: 'CHF', value: 'CHF' },
    ]
    return (
        <>
            <form id='kt_modal_add_user_form' className='form' onSubmit={formik.handleSubmit} noValidate style={{ padding: "0 35px" }}>
                <div className='fv-row mb-7'>
                    <label className='required fw-bold fs-6 mb-2'>Record inward payment</label>
                    <input
                        style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000', // Text color for selected option
                        }}
                        placeholder='Enter amount'
                        {...formik.getFieldProps('amount')}
                        type='number'
                        name='amount'
                        className={clsx(
                            'form-control form-control-solid mb-3 mb-lg-0',
                            { 'is-invalid': formik.touched.amount && formik.errors.amount },
                            {
                                'is-valid': formik.touched.amount && !formik.errors.amount,
                            }
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isUserLoading}
                    />
                    {formik.errors.amount && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.amount}</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className='fv-row mb-7'>
                    <label className='fw-bold fs-6 mb-2'>Total Receivables</label>
                    <input
                        style={{
                            backgroundColor: '#ffffff',
                            border: '1px solid #dddddd',
                            color: '#000000', // Text color for selected option
                        }}


                        placeholder='Total outstanding'
                        // {...formik.getFieldProps('totalOutstanding')}
                        value={user?.totalBalance || ''}
                        type='text'
                        name='totalOutstanding'
                        readOnly
                        className={clsx(
                            'form-control form-control-solid mb-3 mb-lg-0',
                            { 'is-invalid': formik.touched.totalOutstanding && formik.errors.totalOutstanding },
                            {
                                'is-valid': formik.touched.totalOutstanding && !formik.errors.totalOutstanding,
                            }
                        )}
                        autoComplete='off'
                        disabled={formik.isSubmitting || isUserLoading}
                    />
                </div>
                <div className='flex flex-wrap'>
                    <UploadImage
                        // required={true}
                        required={false}
                        name='paymentProof'
                        formik={formik}
                        label='Proof of payment (optional)'
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>

                    <button
                        type='reset'
                        onClick={() => cancel()}
                        className='btn btn-light me-3'
                        data-kt-users-modal-action='cancel'
                        disabled={formik.isSubmitting || isUserLoading}
                    >
                        Discard
                    </button>

                    <button
                        type='submit'
                        className='btn btn-secondary text-white'
                        data-kt-users-modal-action='submit'
                        style={{ backgroundColor: '#333333' }}
                        disabled={isUserLoading || formik.isSubmitting || !formik.isValid || !formik.touched}
                    >
                        <span className='indicator-label'>Submit</span>
                        {(formik.isSubmitting || isUserLoading) && (
                            <span className='indicator-progress'>
                                Please wait...{' '}
                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                        )}
                    </button>


                </div>


            </form>
            {(formik.isSubmitting || isUserLoading) && <UsersListLoading />}
        </>
    )
}

export default WCC2
